import OverviewInterface from "./OverviewInterface"

class OpportunityOverview extends OverviewInterface {

    constructor() {
        super()
        this.linkedtype = 'opportunity'
        this.setMappingName()
        this.fetchRoute = "overview.opportunity.init"
    }

}

export default OpportunityOverview